import { formatDuration, formatSlotRange } from '@betreuung/shared';
import { PersonChip } from '@/components/shared/PersonChip';
import type { PersonLike } from '@/lib/persons';

export interface ScheduleRowItemProps {
  startSlot: number;
  endSlot: number;
  /** `null` marks an unassigned gap, which leads into the create flow. */
  person: PersonLike | null;
  onClick: () => void;
}

/** One line of the upcoming list: when, how long, and who. */
export function ScheduleRowItem({ startSlot, endSlot, person, onClick }: ScheduleRowItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-2.5 border-b border-divider px-4 py-3 text-left hover:bg-muted"
    >
      <span className="min-w-0 flex-1">
        <span className="block text-body font-medium text-fg-secondary">
          {formatSlotRange(startSlot, endSlot)}
        </span>
        <span className="block pt-0.5 font-mono text-duration font-medium text-fg-hint">
          {formatDuration(endSlot - startSlot)}
        </span>
      </span>
      <PersonChip person={person} />
    </button>
  );
}
